
<template>
  <div>
    <data-list :payload="listPayloadObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination"></data-list>
  </div>
</template>
<script>
import DataList from '@/components/DataList.vue'
export default {
  data () {
    return {
      total: 0,
      listPayloadObj: {
        isHeader: true,
        isHideAdd: false,
        selection: [],
        showSelect: true,
        headers: [],
        list: [],
        loading: false,
        addNewRoute: () => this.$router.push('/document_builder/actions'),
        editProp: 'title',
        editURL: (item) => `document_builder/actions/${item.id}`,
        actionsList: [{
          click: (item) => this.downloadHandler(item), // (item) => item,
          title: this.$t('message.common.order_report'),
          icon: () => 'mdi-cloud-download',
          is_show: () => true,
          color: () => 'info'
        }]
      },
      loading: false,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.DOCUMENT_BUILDER_INDEX) ? this.$store.state.DOCUMENT_BUILDER_INDEX : { sortBy: ['title'], itemsPerPage: 25, sortDesc: [false], search: '' },
      MODULE_URL: 'documentreports'
    }
  },
  components: {
    DataList
  },
  computed: {
    headers () {
      return [{
        text: this.$t('message.deviations.title'),
        value: 'title',
        isRoute: true,
        width: '25%'
      }, {
        text: this.$t('message.props.description'),
        value: 'description',
        sortable: false,
        width: '65%'
      }, {
        text: this.$t('message.props.actions'),
        value: 'actions',
        sortable: false,
        exclude: true,
        width: '10%'
      }]
    }
  },
  watch: {
    pagination: {
      handler (val) {
        const model = { type: 'DOCUMENT_BUILDER_INDEX', data: val }
        this.$store.commit('rememberOrder', model)
        this.getListHandler()
      },
      deep: true
    }
  },
  mounted () {
    const text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE_URL) {
        const payload = { ids: data.ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.listPayloadObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      this.listPayloadObj.loading = true
      this.listPayloadObj.module = this.MODULE_URL
      let queryFields = this.$formatter.cloneVariable(this.headers)
      queryFields = queryFields.filter(x => !x.exclude)
      const { page, search, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      const pageVal = page || 1
      const query = {
        order_by: {
          field: sortBy.join(''),
          asc_or_desc: sortDesc[0] ? 'desc' : 'asc'
        },
        skip: ((pageVal - 1) * itemsPerPage),
        limit: itemsPerPage,
        include_count: true,
        filter: `${queryFields.map(x => x.value).join(` contains '${search || ''}' OR `)} contains '${search || ''}'`
      }
      this.$_executeApi('post', `${this.MODULE_URL}/query`, query)
        .then((response) => {
          const { values, count } = response.data
          this.listPayloadObj.loading = false
          this.listPayloadObj.list = values
          this.total = count
        })
    },
    downloadHandler (item) {
      // this.downloadingReport = true
      this.$_executeApi('post', `${this.MODULE_URL}/generate_report/${item.id}`).then((response) => {
        window.open(process.env.VUE_APP_URL + 'file/download/?fileName=' + response.data, '_blank')
      }).finally(() => {
        // this.downloadingReport = false
      })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
